import {
  Box,
  Button,
  Grid,
  IconButton,
  InputAdornment,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import { Brand } from "components-library";
import React, { useState } from "react";
import { useHistory, useParams } from "react-router-dom";
import { useLoginStyles } from "./Login";
import Visibility from "@material-ui/icons/Visibility";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import { Link as RouterLink } from "react-router-dom";
import { useReset } from "@store/actions/authActions";
import { useNotificationContext } from "@providers/NotificationProvider";

function Reset() {
  const { code } = useParams();
  const { bg, body, inner, logo } = useLoginStyles();
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [reset, { loading }] = useReset();
  const { showNotification } = useNotificationContext();
  const history = useHistory();

  const submit = async (e) => {
    e.preventDefault();
    try {
      await reset({ variables: { code, password } });
      showNotification("Password set");
      history.push("/login");
    } catch (e) {
      showNotification("Internal Error");
    }
  };

  return (
    <div className={bg}>
      <div className={body}>
        <Paper className={inner}>
          <Box p={5}>
            <form noValidate autoComplete="off" onSubmit={submit}>
              <Grid
                container
                direction="column"
                alignItems="stretch"
                spacing={3}
              >
                <Grid item xs={8} className={logo}>
                  <Brand useLoad />
                </Grid>
                <Grid item>
                  <Typography>Add a new password</Typography>
                </Grid>
                <Grid item>
                  <TextField
                    onChange={(e) => setPassword(e.target.value)}
                    value={password}
                    fullWidth
                    type={showPassword ? "text" : "password"}
                    disabled={loading}
                    size="small"
                    label="New Password"
                    variant="outlined"
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            aria-label="toggle password visibility"
                            onClick={() => setShowPassword(!showPassword)}
                          >
                            {showPassword ? <Visibility /> : <VisibilityOff />}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>
                <Grid item container alignItems="center" justify="center">
                  <Button
                    disabled={loading}
                    color="primary"
                    type="submit"
                    variant="contained"
                    size="large"
                    fullWidth
                  >
                    Reset Password
                  </Button>
                </Grid>
                <Grid item>
                  <RouterLink to="/login">{"<"} Back to login</RouterLink>
                </Grid>
              </Grid>
            </form>
          </Box>
        </Paper>
      </div>
    </div>
  );
}

export default Reset;
